import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Grid,
    Box,
    Typography,
    Pagination,
    PaginationItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Checkbox,
    Popover,
    TableSortLabel,
} from '@mui/material';
import {
    CustomAccordion,
    CustomButton,
    CustomModal,
    TableRowsSkeleton,
} from '../../../../shared';
import {
    ActionsIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
    Edit,
    Trash,
} from '../../../../../assets';
import { useSelector, useDispatch } from 'react-redux';
import {
    deleteQuery,
    getAllTriggers,
    getTriggerById,
} from '../../../../../redux/thunks/triggerThunk';
import { actions } from '../../../../../redux/reducers/adminSettingsReducer';
import ConfirmationDelete from '../confirmationDelete';
import routeNames from '../../../../../routes/routeNames';
import { getSortedData } from '../../../../../utility';
import {
    deleteChannelAction,
    getChannelActionById,
    getChannelActions,
} from '../../../../../redux/thunks/adminSettingsThunk';
import EditCreateChannelActions from '../editCreateChannelActions';

function ChannelActionsTable(props) {
    const {} = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [openDelete, setOpenDelete] = useState(false);
    const { company } = useSelector((state) => state.company);
    const { isLoading, channelActions } = useSelector(
        (state) => state.adminSettings
    );
    const { totalPages, channelActionsData, currentPage, pageSize } =
        channelActions;
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState(null);

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };
    const createSortHandler = (property) => () => {
        handleRequestSort(property);
    };

    const sortedData = React.useMemo(() => {
        return getSortedData(orderBy, order, channelActionsData);
    }, [order, orderBy, channelActionsData]);

    //  const handleCheckboxChange = (id) => {
    //     dispatch(actions.handleSelected({ type: 'SET_SELECTED_ROWS', selectedId: id }));
    // };

    // const handleSelectAll = () => {
    //     dispatch(actions.handleSelected({ type: 'SELECT_ALL' }));
    // };

    const handlePopoverOpen = (event, rowId) => {
        event.preventDefault();
        setAnchorEl(event.currentTarget);
        setSelectedRowId(rowId);
    };

    const handlePopoverClose = (row) => {
        setAnchorEl(null);
        setSelectedRowId(null);
    };

    const handleEdit = (rowId) => {
        handlePopoverClose();
        dispatch(actions.handleChannelActionModal('Edit'));
        dispatch(getChannelActionById({ id: rowId }));
    };

    const handleQueryRowClick = (event, rowId) => {
        const isCheckboxColumn = event.target.closest('.table-row-checkbox');
        const isActionsColumn = event.target.closest('.table-row-actions');
        const isPopoverOpen = Boolean(anchorEl);
        if (!isCheckboxColumn && !isActionsColumn && !isPopoverOpen) {
            handleEdit(rowId);
            handlePopoverClose();
        }
    };

    const handleDelete = (rowId) => {
        dispatch(deleteChannelAction({ id: rowId })).then((result) => {
                dispatch(getChannelActions({ companyId: company.id }));
        });
        onclose();
    };
    const handleDeleteOpen = () => {
        setOpenDelete(!openDelete);
    };
    const onclose = () => {
        handlePopoverClose();
        setOpenDelete(!openDelete);
    };
    const handlePageChange = (event, page) => {
        dispatch(actions.setCurrentPage(page));
    };

    const handleNextClick = () => {
        if (currentPage < totalPages) {
            handlePageChange(_, currentPage + 1);
        }
    };

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            handlePageChange(_, currentPage - 1);
        }
    };
    const renderNoData = () => {
        return (
            <TableRow>
                <TableCell colSpan={5}>
                    <Box textAlign="center" p={3}>
                        <Typography className="text-sm-regular gray-900">
                            No data to display.
                        </Typography>
                    </Box>
                </TableCell>
            </TableRow>
        );
    };

    const renderTable = () => {
        const startIdx = (currentPage - 1) * pageSize;
        const endIdx = currentPage * pageSize;
        return channelActionsData.length > 0
            ? sortedData?.slice(startIdx, endIdx).map((row, index) => {
                  return (
                      <>
                          <TableRow
                              key={row.id}
                              onClick={(event) =>
                                  handleQueryRowClick(event, row.id)
                              }
                              className="icon"
                          >
                              {/* <TableCell className='table-row-data no-border table-row-checkbox' >
                            <Checkbox
                                checked={selected.includes(row.id)}
                                onChange={() => handleCheckboxChange(row.id)}
                            />
                        </TableCell> */}
                              <TableCell className="table-row-data no-border">
                                  {row.channel_name}
                              </TableCell>
                              <TableCell className="table-row-data no-border">
                                  {row.action_name}
                              </TableCell>
                              <TableCell className="table-row-data no-border">
                                  {row.engagement === false ? 'No' : 'Yes'}
                              </TableCell>
                              <TableCell className="table-row-data no-border cursor-pointer table-row-actions">
                                  <img
                                      src={ActionsIcon}
                                      height={20}
                                      width={20}
                                      onClick={(event) =>
                                          handlePopoverOpen(event, row.id)
                                      }
                                  />
                                  <Popover
                                      open={selectedRowId === row.id}
                                      anchorEl={anchorEl}
                                      onClose={handlePopoverClose}
                                      anchorOrigin={{
                                          vertical: 'bottom',
                                          horizontal: 'right',
                                      }}
                                      transformOrigin={{
                                          vertical: 'top',
                                          horizontal: 'right',
                                      }}
                                      disableScrollLock={true}
                                      sx={{
                                          '& .MuiPaper-root': {
                                              boxShadow: 'none',
                                          },
                                      }}
                                  >
                                      <Box>
                                          <Box
                                              className="action-button-box table-row-actions"
                                              onClick={() => handleEdit(row.id)}
                                          >
                                              <Edit color="#667085" />
                                              <Typography className="action-button-text">
                                                  Edit
                                              </Typography>
                                          </Box>
                                          <Box
                                              className="action-button-box table-row-actions"
                                              onClick={handleDeleteOpen}
                                          >
                                              <Trash color="#667085" />
                                              <Typography className="action-button-text">
                                                  Delete
                                              </Typography>
                                          </Box>
                                      </Box>
                                  </Popover>
                              </TableCell>
                          </TableRow>
                          <ConfirmationDelete
                              open={openDelete}
                              onClosed={onclose}
                              onConfirms={() => handleDelete(row.id)}
                          />
                      </>
                  );
              })
            : renderNoData();
    };

    const channelActionsTableComponent = () => (
        <>
            <TableContainer
                component={Paper}
                className="no-box-shadow no-border"
            >
                <Table className="table-border-collapse no-border">
                    <TableHead className="queries-table-heading">
                        <TableRow height={'40px'}>
                            {/* <TableCell className="queries-headers-title">
                            <Checkbox
                                checked={selectAll}
                                onChange={handleSelectAll}
                            />
                        </TableCell> */}
                            <TableCell className="queries-headers-title">
                                <TableSortLabel
                                    active={orderBy === 'channel_name'}
                                    direction={
                                        orderBy === 'channel_name'
                                            ? order
                                            : 'asc'
                                    }
                                    onClick={createSortHandler('channel_name')}
                                >
                                    Channel Name
                                </TableSortLabel>
                            </TableCell>
                            <TableCell className="queries-headers-title">
                                <TableSortLabel
                                    active={orderBy === 'action_name'}
                                    direction={
                                        orderBy === 'action_name'
                                            ? order
                                            : 'asc'
                                    }
                                    onClick={createSortHandler('action_name')}
                                >
                                    Action
                                </TableSortLabel>
                            </TableCell>
                            <TableCell className="queries-headers-title">
                                <TableSortLabel
                                    active={orderBy === 'engagement'}
                                    direction={
                                        orderBy === 'engagement' ? order : 'asc'
                                    }
                                    onClick={createSortHandler('engagement')}
                                >
                                    Engagement
                                </TableSortLabel>
                            </TableCell>
                            <TableCell className="queries-headers-title"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isLoading ? (
                            <TableRowsSkeleton rows={10} columns={4} />
                        ) : (
                            renderTable()
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {/* Table Footer */}
            {totalPages ? (
                <Box className="padding-tb-16-rl-24 border-top-gray">
                    <Box className="flex-row-space-between-center">
                        <Box>
                            <CustomButton
                                title="Previous"
                                titleColor="#344054"
                                buttonColor="#FFFFFF"
                                icon={<ArrowLeftIcon />}
                                customStyle={{ borderRadius: '8px' }}
                                handleClick={handlePreviousClick}
                                buttonDisabled={!(currentPage !== 1)}
                            />
                        </Box>

                        {/* Pagination */}
                        <Box>
                            <Pagination
                                shape="rounded"
                                count={totalPages}
                                page={currentPage}
                                hidePrevButton
                                hideNextButton
                                onChange={handlePageChange}
                            />
                        </Box>

                        <Box>
                            <CustomButton
                                title="Next"
                                titleColor="#344054"
                                buttonColor="#FFFFFF"
                                tailIcon={<ArrowRightIcon />}
                                customStyle={{ borderRadius: '8px' }}
                                handleClick={handleNextClick}
                                buttonDisabled={!(totalPages > currentPage)}
                            />
                        </Box>
                    </Box>
                </Box>
            ) : null}
        </>
    );

    return (
        <Box className="b1px-border-box-br8px">
            <CustomAccordion
                title="See Full List Below"
                component={channelActionsTableComponent()}
                accordionContainerBackground="bg-primary-50"
                accordionTitleColor="primary-color"
                acoordianDetailsBackground="bg-gray-50"
                byDefaultOpen={true}
            />
        </Box>
    );
}

export default ChannelActionsTable;
